<!-- <template>
  <div class="wrapper">
    <div class="animated slide"
      v-for="(value, key) in slides"
      :key="key"
      :class="value.class"
      >
      <component :is="value.componentName" :dataId="key"></component>
    </div>
    <button class="prev" @click="previousSlide">{{prevLabel}}</button>
    <button class="next" @click="nextSlide">{{nextLabel}}</button>
  </div>
</template> -->

<script>
import TitleSlide from '../../components/title-slide/TitleSlide'
import DragDropTarget from '../../components/drag-drop-target/DragDropTarget'
import SelectObject from '../../components/select-object/SelectObject'
import QuizMultiple from '../../components/quiz-multiple/QuizMultiple'
import InfoModal from '../../components/info-modal/InfoModal'
import TextHighlight from '../../components/text-highlight/TextHighlight'
import Quizzes from '../../components/quizzes/Quizzes'
import ResultBoard from '../../components/result-board/ResultBoard'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'MainInteractive',
  components: {
    TitleSlide,
    DragDropTarget,
    SelectObject,
    QuizMultiple,
    TextHighlight,
    InfoModal,
    Quizzes,
    ResultBoard
  },
  data () {
    return {
      prevLabel: '<',
      nextLabel: '>',
      backgroundImage: ''
    }
  },
  render (createElement) {
    let elemList = []
    let componentList = []

    elemList.push(createElement('div', {
      attrs: {
        class: 'currentBackground background'
      },
      style: {
        backgroundImage: 'url(' +
          (require('../../assets/' + ((this.currentBackground !== null) ? this.currentBackground : 'images/lead-inter-asset-leadBg.png'))) +
          ')'
      }
    }))

    elemList.push(createElement('div', {
      attrs: {
        class: 'nextBackground background'
      },
      style: {
        backgroundImage: 'url(' +
          (require('../../assets/' + ((this.nextBackground !== null) ? this.nextBackground : 'images/lead-inter-asset-leadBg.png'))) +
          ')'
      }
    }))

    for (let index = 0; index < this.componentIdOrder.length; index++) {
      let dataId = this.$store.state.componentIdOrder[index]
      let dataObject = this.$store.getters.getData(dataId)
      let componentType = dataObject.componentName
      let componentClass = dataObject.class
      let component = createElement(componentType, {
        props: {
          dataId: dataId,
          isActive: (this.componentIdOrder[index] === this.activeSlide)
        }
      })
      let compWrap = createElement('div', {
        class: {
          ['inner-wrap comp-wrap animated slide ' + componentClass]: true
        },
        attrs: {
          'aria-hidden': (this.componentIdOrder[index] === this.activeSlide) ? 'false' : 'true'
        }
      }, [component])
      componentList.push(compWrap)
    }

    let sliderWrap = createElement('div', {
      attrs: {
        class: 'inner-wrap slide-wrap animated slide'
      }
    }, componentList)
    elemList.push(sliderWrap)

    let logo = this.createElemLogo(createElement)
    elemList.push(logo)

    let prevIcon = createElement('v-icon', 'arrow-back-ios')
    let tempElem = []
    tempElem.push(prevIcon)
    if (this.componentIdOrder.length > 1 && this.interactiveInfo.hasNavigation) {
      let prevButton = createElement('v-btn', {
        attrs: {
          class: 'nav-button left-nav',
          tabIndex: '98',
          'aria-label': 'previous'
        },
        on: { click: this.previousSlide }
      }, this.prevLabel)
      elemList.push(prevButton)
    }

    if (this.componentIdOrder.length > 1 && this.interactiveInfo.hasNavigation) {
      let nextButton = createElement('button', {
        attrs: {
          class: 'nav-button right-nav'
        },
        on: { click: [this.nextSlide] }
      }, this.nextLabel)
      elemList.push(nextButton)
    }
    // let container = createElement('div', widgetList)
    // this.populateScoreData

    return createElement('div', {
      attrs: {
        class: 'comp-main-inter' + ((this.animateBackground) ? ' animateBackground' : '')
      }
      // ,
      // style: {
      //   backgroundImage: 'url(' +
      //     (require('../../assets/' + ((this.themes !== undefined) ? this.themes.backgroundPath : 'images/lead-inter-asset-leadBg.png'))) +
      //     ')'
      // }
    }, elemList)
  },
  computed: {
    ...mapState({
      slides: state => state.componentData,
      activeSlide: 'activeSlide',
      componentIdOrder: state => state.componentIdOrder,
      interactiveInfo: state => state.interactiveData,
      currentBackground: 'currentBackground',
      nextBackground: 'nextBackground',
      animateBackground: 'animateBackground'
    }),
    content () {
      return this.$store.getters.getData(this.activeSlide)
    },
    themes () {
      if (this.content.data.category) {
        return this.$store.getters.getThemes(this.content.data.category)
      }
    }
  },
  created () {
    // this.randomizeComponent()
    // this.setScoreData()
    this.goToSlide(0)
  },
  methods: {
    ...mapMutations([
      'nextSlide',
      'previousSlide',
      'randomizeComponent',
      'setScoreData',
      'goToSlide'
    ]),
    setScore () {
      this.setScoreData()
    },
    createElemLogo (createElement) {
      let logoElem = []
      let shadowRec = createElement('div', {
        attrs: { class: 'elems shadow' }
      })
      logoElem.push(shadowRec)

      let whiteRec = createElement('div', {
        attrs: { class: 'elems rect' }
      })
      logoElem.push(whiteRec)

      let logo = createElement('div', {
        attrs: { class: 'elems logo' }
      })
      logoElem.push(logo)

      let logoWrap = createElement('div', {
        attrs: { class: 'logo-wrap' }
      }, logoElem)
      return logoWrap
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./style.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/main-interactive/MainInteractive.vue